import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	pageTitle: {
		id: 'polaris-apps-unlicensed.page-title',
		defaultMessage: 'Jira Product Discovery',
		description: 'Onboarding page title',
	},
	header: {
		id: 'polaris-apps-unlicensed.header',
		defaultMessage: 'Jira Product Discovery has been deactivated',
		description: 'License error page header.',
	},
	description: {
		id: 'polaris-apps-unlicensed.description',
		defaultMessage:
			'Please contact your site administrator to reactivate Jira Product Discovery and regain access.',
		description: 'License error description and help text.',
	},
	action: {
		id: 'polaris-apps-unlicensed.action',
		defaultMessage: 'View a list of all projects',
		description: 'Text on the link to the project page.',
	},
	betaHeader: {
		id: 'polaris-apps-unlicensed.beta-header',
		defaultMessage: 'Select a Free or Standard plan to get access',
		description: 'Beta program ended page header.',
	},
	betaDescription: {
		id: 'polaris-apps-unlicensed.beta-description',
		defaultMessage:
			"The Beta edition is no longer available. We are grateful for all the feedback you've provided during our beta period, which has helped us shape the product into what it is today. To continue using Jira Product Discovery, please update your plan to Free or Standard. Moving to the Standard edition starts a free 14 day trial, you can use this time to request an annual quote if required.",
		description: 'Beta program ended page description for user with admin permissions.',
	},
	betaDescriptionNonAdmin: {
		id: 'polaris-apps-unlicensed.beta-description-non-admin',
		defaultMessage:
			'The Beta plan is no longer available. To continue using Jira Product Discovery, please contact your site admin to update the plan to Free or Standard.',
		description: 'Beta program ended page description for user without admin permissions.',
	},
	contactSupport: {
		id: 'polaris-apps-unlicensed.contact-support',
		defaultMessage: 'Contact support',
		description: 'Button label to contact support.',
	},
	managePlan: {
		id: 'polaris-apps-unlicensed.manage-plan',
		defaultMessage: 'Manage plan',
		description: 'Button label to link to admin section.',
	},
	learnMore: {
		id: 'polaris-apps-unlicensed.learn-more',
		defaultMessage: 'Check out our detailed instructions to regain access.',
		description: 'Button label to link to documentations on how to upgrade.',
	},
});
